// extracted by mini-css-extract-plugin
module.exports = {"container":"FirstSection_container__27lyc","title_container":"FirstSection_title_container__2QnGX","title":"FirstSection_title__2pKov"};